import { gql } from '@apollo/client'

export const MUTATION_SPELL_CHECK = gql`
  mutation ($input_text: String!) {
    SpellCheck(input_text: $input_text) {
      statusCode
      message
      data
    }
  }
`

export const QUERY_SPELL_CHECK_STATUS = gql`
  query ($job_id: ID!) {
    SpellCheckJob(job_id: $job_id) {
      statusCode
      message
      data
    }
  }
`
